/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".icon-tooltip[_ngcontent-%COMP%]{margin-left:5px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/core/achoo-icon-tooltip/achoo-icon-tooltip.component.scss.shim.ngstyle.js.pre-build-optimizer.js